module.exports = __webpack_public_path__ + "static/media/saiKiruba.67545120.png";